import * as types from './workstationStateActionTypes.js';

export const setWorkstationWithScissorStatusInfo = (workstationsWithScissorStatusInfo) => ({type: types.SET_WORKSTATIONWITHSCISSORSTATUSINFO, workstationsWithScissorStatusInfo: workstationsWithScissorStatusInfo});


